import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clear",
  "use": "clear-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"clear\"><path fill-rule=\"nonzero\" d=\"M20.293 6.293l1.414 1.414L15.415 14l6.292 6.293-1.414 1.414L14 15.415l-6.293 6.292-1.414-1.414L12.585 14 6.293 7.707l1.414-1.414L14 12.585z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol